import { Figure } from '@studiometa/ui';

/**
 * FigureExternal component.
 */
export default class FigureExternal extends Figure {
  static config = {
    ...Figure.config,
    name: 'FigureExternal',
  };
}
